import { ClassificationReason, RLCard } from "../../../../../../components";
import { ClassificationImage } from "../../../../../commons/header";
import RiskScoreScale from "../../../RiskScoreScale";
import {
  Detections,
  MultiScanner,
  YaraDetections
} from "../../../header/detections";
import { Info } from "../../../header/info";
import { ThreatInfo } from "../../../header/threat-info";

import styles from "./layout-blocks.module.scss";

const MainHeader = () => (
  <header className={styles.main_header}>
    <ClassificationImage classification="unknown" fileType="exe" />
    <RLCard
      className={styles.main_header_card}
      content={
        <RLCard.Content>
          <Info />
        </RLCard.Content>
      }
      style={{ border: "none" }}
    />
    <RLCard
      className={styles.main_header_card}
      header={
        <RLCard.Header>
          <div style={{ fontSize: "14px", margin: "auto" }}>Risk Score</div>
        </RLCard.Header>
      }
      content={
        <RLCard.Content style={{ padding: "0.25rem" }}>
          <div className={styles.risk_score}>
            <span className={styles.label}>X</span>
            <RiskScoreScale classification="unknown" factor={5} />
          </div>
        </RLCard.Content>
      }
    />
    <RLCard
      className={styles.main_header_card}
      header={
        <RLCard.Header>
          <div style={{ fontSize: "14px", margin: "auto" }}>
            Threat Name / Actor
          </div>
        </RLCard.Header>
      }
      content={
        <RLCard.Content>
          <ThreatInfo name="Threat Name" actors={["Threat Actor"]} />
        </RLCard.Content>
      }
    />
    <RLCard
      className={styles.main_header_card}
      header={
        <RLCard.Header>
          <div style={{ fontSize: "14px", margin: "auto" }}>
            Classification Reason
          </div>
        </RLCard.Header>
      }
      content={
        <RLCard.Content>
          <ClassificationReason
            title="Classification Reason"
            label="Classification Source"
          />
        </RLCard.Content>
      }
    />
    <RLCard
      className={styles.main_header_card}
      header={
        <RLCard.Header>
          <div style={{ fontSize: "14px", margin: "auto" }}>Detections</div>
        </RLCard.Header>
      }
      content={
        <RLCard.Content style={{ padding: "0" }}>
          <Detections>
            <MultiScanner count="X" match="y" />
            <YaraDetections matches="X" />
          </Detections>
        </RLCard.Content>
      }
    />
  </header>
);

export default MainHeader;
